module.exports = __webpack_public_path__ + "img/unionpay.aff58e55.png";